export class AppAuthResult {
	constructor(
		private success: boolean,
		private response: unknown = null,
		private redirectTo: string | null = null,
		private errors: string[] = [],
		private messages: string[] = [],
		private token: unknown = null,
	) {}

	isSuccess(): boolean {
		return this.success;
	}

	getResponse(): unknown {
		return this.response;
	}

	getRedirect(): string | null {
		return this.redirectTo;
	}

	getErrors(): string[] {
		return this.errors;
	}

	getMessages(): string[] {
		return this.messages;
	}

	getToken(): unknown {
		return this.token;
	}
}
